import { render, staticRenderFns } from "./HostName.vue?vue&type=template&id=2877958c&scoped=true"
import script from "./HostName.vue?vue&type=script&lang=js"
export * from "./HostName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2877958c",
  null
  
)

export default component.exports